import { FieldLabel, FieldValue, Stack } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'

import React from 'react'
import { ApiCustomer } from '@vend/types'
import { CustomerSearch } from '../../../../../customer/customer-search'
import { LineItemFulfilmentCustomerHeaderView } from '../LineItemFulfilmentCustomerHeaderView'

type LineItemFulfilmentAddCustomerViewProps = {
  onAddNewCustomer: () => void
  onSelectCustomer: (customer: ApiCustomer | null) => void
}

export const LineItemFulfilmentAddCustomerViewLegacy: React.FC<LineItemFulfilmentAddCustomerViewProps> = ({
  onAddNewCustomer,
  onSelectCustomer,
}: LineItemFulfilmentAddCustomerViewProps) => {
  const t = useT()
  return (
    <Stack space={6}>
      <LineItemFulfilmentCustomerHeaderView />
      <FieldLabel label={t('Customer')}>
        <FieldValue>
          <CustomerSearch
            placeholder={t('Add a customer')}
            onAdd={onAddNewCustomer}
            onSelect={onSelectCustomer}
          />
        </FieldValue>
      </FieldLabel>
    </Stack>
  )
}
